import routes from './routes'
import store from './store'

export default {
    name: 'm-utils',
    store: store,
    routes: routes
}